module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_forum1.6c859.png";